<body>
    <div class="main-content">
        <div class="logoblock">
            <img src="../../assets/images/BRAND.png" alt="Logo Billcentrix">
            <div><app-menu></app-menu></div>
        </div>
        
        <div class="create-portal">
            <h1>{{ 'loginOnboard.title' | translate }}</h1>
            <div class="modal-center">
                <img src="../../assets/icons/box.svg" alt="imagen de cubo">

                <p>{{ 'loginOnboard.welcome' | translate }}</p>
                <button (click)="goStep()">{{ buttonText }}</button>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</body>